import { formatDate } from '@repo/ui/utils'
import { isSameDay } from 'date-fns'
import { useT } from './hooks'

type ChatDayMessagesProps = {
  children?: React.ReactNode
  day: string
}

export default function ChatDayMessages({
  children,
  day,
}: ChatDayMessagesProps) {
  const { tc } = useT()
  const now = new Date()
  const date = isSameDay(new Date(day), now)
    ? tc('today')
    : formatDate(new Date(day).toDateString())
  return (
    <div className="flex flex-col">
      <div className="my-2 flex items-center justify-center">
        <span className="border-primary-200 text-primary-400 select-none rounded-xl border-b px-3 pb-1 pt-3 text-xs shadow-sm">
          {date}
        </span>
      </div>
      {children}
    </div>
  )
}
